// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.personal-feedback__feedback[data-v-ac7f0084] {\n  padding: 10px;\n  border-radius: 3px;\n  white-space: pre-wrap;\n  overflow-wrap: break-word;\n}\n.personal-feedback__feedback--dark[data-v-ac7f0084] {\n  background-color: #e9ddcc;\n}\n.personal-feedback__feedback--light[data-v-ac7f0084] {\n  background-color: #cce6e7;\n}\n.personal-feedback__note[data-v-ac7f0084] {\n  color: #b68e56;\n}\n\n", ""]);
// Exports
module.exports = exports;
